import React from 'react';
import { Logo } from './Logo';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function Nav() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleCtaClick = () => {
    openDiagnostic();
  };
  return <header className="w-full py-5 px-6 md:px-12 flex items-center justify-between bg-paper/80 backdrop-blur-md sticky top-0 z-40 border-b border-gray-100 shadow-sm" data-id="element-284" data-mp="1g0h0ycrrshwt">
      <Logo data-id="element-285" data-mp="1ppiezxer8p85" />
      <div className="hidden md:block" data-id="element-286" data-mp="1ppqulx29i8n1">
        <Cta variant="primary" onClick={handleCtaClick} className="text-sm py-2.5 px-5 shadow-sm hover:shadow" data-id="element-287" data-mp="1pqtl43voa92f">
          
          {ctaLabel}
        </Cta>
      </div>
    </header>;
}